var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 731.836,
    height: 490.096,
    viewBox: "0 0 731.836 490.096",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-781.668 -1539.464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1013.7,371.9V574.584H505.9A101.4,101.4,0,0,1,498.853,371.9q3.524-.123,7.051,0Z",
    transform: "translate(487.327 1448.739)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.991,576.753a7.8,7.8,0,0,1-7.8,7.8H505.675a106.8,106.8,0,0,1,0-213.6H1027.2a7.8,7.8,0,1,1,0,15.591H505.675a91.208,91.208,0,0,0,0,182.415H1027.2A7.8,7.8,0,0,1,1034.991,576.753Z",
    transform: "translate(478.512 1445.01)",
    fill: "#DE3433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.817,383.359H415.13a1.559,1.559,0,0,1-.029-3.118H960.817a1.559,1.559,0,0,1,0,3.118Z",
    transform: "translate(540.218 1484.053)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.817,390.551H415.13a1.559,1.559,0,1,1-.029-3.118H960.817a1.559,1.559,0,1,1,0,3.118Z",
    transform: "translate(540.218 1514.28)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.817,397.742H415.13a1.559,1.559,0,0,1-.029-3.118H960.817a1.559,1.559,0,0,1,0,3.118Z",
    transform: "translate(540.218 1544.506)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.817,404.934H415.13a1.559,1.559,0,1,1-.029-3.118H960.817a1.559,1.559,0,0,1,0,3.118Z",
    transform: "translate(540.218 1574.733)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.3,330.859V533.542h-507.8a101.4,101.4,0,0,1-7.051-202.684q3.524-.123,7.051,0Z",
    transform: "translate(410.005 1276.242)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.594,535.712a7.8,7.8,0,0,1-7.8,7.8H487.278a106.8,106.8,0,1,1,0-213.6H1008.8a7.8,7.8,0,1,1,0,15.591H487.278a91.208,91.208,0,0,0,0,182.415H1008.8a7.8,7.8,0,0,1,7.8,7.8Z",
    transform: "translate(401.189 1272.513)",
    fill: "#DE3433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.42,342.318H396.733a1.559,1.559,0,1,1-.029-3.118H942.42a1.559,1.559,0,1,1,0,3.118Z",
    transform: "translate(462.887 1311.555)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.42,349.509H396.733a1.559,1.559,0,1,1-.029-3.118H942.42a1.559,1.559,0,1,1,0,3.118Z",
    transform: "translate(462.887 1341.782)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.42,356.7H396.733a1.559,1.559,0,1,1-.029-3.118H942.42a1.559,1.559,0,1,1,0,3.118Z",
    transform: "translate(462.887 1372.009)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.42,363.893H396.733a1.559,1.559,0,1,1-.029-3.118H942.42a1.559,1.559,0,1,1,0,3.118Z",
    transform: "translate(462.887 1402.235)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.778,317.831H496.42a14.293,14.293,0,0,0-6.331,1.473l-58.394,29.233a10.641,10.641,0,0,0,0,19.587l58.393,29.233a14.3,14.3,0,0,0,6.332,1.473H727.778a12.143,12.143,0,0,0,12.814-11.266V329.1A12.143,12.143,0,0,0,727.778,317.831Z",
    transform: "translate(589.22 1221.654)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.416,329.1v58.465A12.143,12.143,0,0,1,520.6,398.828H474.509v-81H520.6A12.143,12.143,0,0,1,533.416,329.1Z",
    transform: "translate(796.404 1221.656)",
    fill: "#DE3433"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroi);
export default __webpack_public_path__ + "static/media/heroi.b592bd0961f4049b12b210342a2a8957.svg";
export { ForwardRef as ReactComponent };